<!--  9.9支付抢购 -->
<template>
<div v-if="bodyShow">
  <div class="rush-main" @click="showModal" >
      <div class="pb">
        <img src="https://misc.xjy.cn/accelerator/growth/20210525/1.png">
        <img src="https://misc.xjy.cn/accelerator/growth/20210525/2.png">
        <img src="https://misc.xjy.cn/accelerator/growth/20210525/3.png">
        <img src="https://misc.xjy.cn/accelerator/growth/20210525/4.png">
        <img src="https://misc.xjy.cn/accelerator/growth/20210525/5.png">
        <img src="https://misc.xjy.cn/accelerator/growth/20210525/6.png">
      </div>
      <div class="media-rush">
        <img class="media-rush-img" src="https://misc.xjy.cn/accelerator/growth/20210514/bottom.png">
        <img class="media-rush-btn" src="https://misc.xjy.cn/accelerator/growth/20210514/btn.png">
        <div class="timer-box xh">{{hour}}</div>
        <div class="timer-box xm">{{minute}}</div>
        <div class="timer-box xs">{{second}}</div>
      </div>
      <van-popup v-model="showDialog" :close-on-click-overlay="false">
        <div @click.stop class="rush-dialog">
            <img src="https://misc.xjy.cn/accelerator/growth/20210514/dialog.png">
            <input type="tel" class="phone" v-model="phone" placeholder="请输入手机号">
            <input type="number" class="code" v-model="code" placeholder="请输入验证码">
            <a href="javascript:;" class="valid" @click="getCodeHandle">{{codeText}}</a>
            <a href="javascript:;" class="btn" @click="validatorHandle"></a>
            <p class="time">{{hour}}:{{minute}}:{{second}}</p>
        </div>
      </van-popup>
      <van-popup v-model="showConfirm" :close-on-click-overlay="false">
          <div class="rush-confirm">
              <img src="https://misc.xjy.cn/accelerator/growth/back.png">
              <div class="btn-group">
                  <a href="javascript:;" class="btn-cancel" @click="deny" @click.stop>残忍拒绝</a>
                  <a href="javascript:;" class="btn-confirm" @click="accept" @click.stop>继续支付</a>
              </div>
          </div>
      </van-popup>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import { wxpay,h5wxpay,orders,checkpay,toutiao_track,check_phone,baidu_track,qq_track } from "@/api/other";
import { getStorage, setStorage, deepCopy,deleteStorage, isWeixin,queryString,delParam,isMain } from "@/utils/tools";
import { phoneValidation,events } from "@/utils/validation";
// import {Dialog} from 'vant';
export default {
    data(){
        return{
            data:{},
            bodyShow:false,
            checkBool:false,
            name:'',
            phone:null,
            bool:true,
            qrcodeShow:false,
            qrType:'',
            isBuy: false,
            clientHeight: 1334,
            hour: '00',
            minute: '05',
            second: '00',
            time_in_sec: 600,
            timer: null,
            buy_id: 9,
            buy_id2: 9,
            sms_id: null,
            code: null,
            codeText: '获取验证码',
            time: 60,
            canClick: true,
            retry: 4,
            Url: isMain() ? 'https://open.xjy.cn/api' : 'https://open.xjy.cn/dev',
            showDialog: false,
            showConfirm: false,
        }
    },
    mounted(){
        this.clientHeight = document.documentElement.clientHeight;
        this.timer = setInterval(()=>{
            if(this.time_in_sec > 0) {
                this.time_in_sec--;
                
                let second = this.time_in_sec;
                let hour = Math.floor(second / 3600);
                second -= 3600 * hour;
                let minute = Math.floor(second / 60);
                second -= 60 * minute;

                this.hour = hour >= 10 ? hour + '' : '0' + hour;
                this.minute = minute >= 10 ? minute + '' : '0' + minute;
                this.second = second >= 10 ? second + '' : '0' + second;
            } else {
                this.time_in_sec = 600;
                // clearInterval(this.timer);
            }
        }, 1000);

        history.pushState(null, null, window.location.href);
        window.addEventListener('popstate', this.exit_dialog);
    },
    destroyed() {
        window.removeEventListener("popstate", this.exit_dialog);
    },
    methods:{
        deny(){
            this.showConfirm = false;
        },
        accept(){
            history.pushState(null, null, window.location.href);
            this.showConfirm = false;
            this.showDialog = true;
        },
        showModal(){
            if(this.showConfirm) {
                return;
            }
            this.showDialog = !this.showDialog;
        },
        exit_dialog(){
            // console.log('exit_dialog');
            this.showConfirm = true;
        },
        // 滚动到指定位置
        setScrollTo(){
            var el=document.getElementById('form');
            this.$nextTick(function () {
                window.scrollTo({"behavior":"smooth","top":el.offsetTop});
            })
        },
        checkCodeHandle(){
            let self = this;

            if(!self.sms_id) {
                self.$toast('请发送验证码');
                return;
            }
            
            if(!self.code) {
                self.$toast('请输入验证码');
                return;
            }

            // 验证验证码是否正确
            let params = new URLSearchParams();
            params.append('code', self.code);
            params.append('sms_id', self.sms_id);
            axios.post(self.Url+'/cms/check_sms', params).then(success=>{
                if(success.data.error != 0){
                    self.$toast(success.data.msg);
                    return;
                }
                function send_crm() {
                    let params = new URLSearchParams();
                    params.append('phone', self.phone);
                    params.append('source', "9.9转化营5");
                    params.append('name', self.name);
                    axios.post(self.$Url+'crm/', params).then(success=>{
                        if(success.status!=200){
                            self.$toast(success.statusText);
                            return
                        }
                        if(success.data.status==1){
                            self.$toast('提交成功！');
                        }
                    });

                    self.baiduHandle();
                    self.toutiaoHandle();
                    self.qqHandle();
                    
                    self.payHandle();
                }

                window.onOK = function() {
                    send_crm();
                }

                window.onError = function() {
                    send_crm();
                }

                // if(typeof sendPage == 'function') {
                //     sendPage(self.phone, self.name);
                // } else {
                    send_crm();
                // }
            });
        },
        // 获取验证码
        getCodeHandle(){
            if(!this.canClick){
                return;
            }

            // 验证手机号是否正确
            if(!phoneValidation(this.phone)){
                this.$toast('请输入正确的手机号！');
                return
            }
            // 倒计时
            events(this.codeText, this.time, this.canClick, (codeText, time, canClick) => {
                this.codeText = codeText;
                this.time = time;
                this.canClick = canClick;
            });

            let params = new URLSearchParams();
            params.append('mobile', this.phone);
            axios.post(this.Url+'/cms/send_sms', params).then(success=>{
                if(success.data.error != 0){
                    self.$toast(success.data.msg);
                    return
                }else{
                    this.sms_id = success.data.sms_id;
                }
            });
        },
        // 验证信息
        validatorHandle(){
            let self = this;

            if(!self.phone){
                self.$toast('手机号不能为空！');
                self.bool = false;
                return
            }
            if(!phoneValidation(self.phone)){
                self.$toast('请输入正确的手机号！');
                return
            }
            // if(!self.checkBool){
            //     self.$toast('请先同意《个人信息授权与保护声明》！');
            //     return
            // }
            // if(self.checkBool){
            //     setStorage(self.$route.path, 'userObj', {
            //         name:self.name,
            //         phone:self.phone,
            //         checkBool:self.checkBool
            //     });
            // }else{
            //     deleteStorage(self.$route.path);
            // }
            
            // 验证是否存在手机号
            check_phone({
                phone:self.phone
            }).then(res=>{
                if (res.code == 10002) {
                    self.$toast(res.data.msg);
                    return ;
                }
                if(res.exist && isMain()){
                    self.$toast('本课程仅限新精英新用户领取！');
                    return ;
                }

                self.checkCodeHandle();
            });

        },
        // 百度统计请求
        baiduHandle(){
            baidu_track({
                conversionTypes:[ {
                    "logidUrl": window.location.href,
                    "newType": 3
                }]
            }).then(res=>{
                
            });
        },
        toutiaoHandle(){     
            toutiao_track({
                referer: window.location.href
            }).then(data=>{
            });
        },
        qqHandle(){
            let click_id = this.$route.query.qz_gdt || this.$route.query.gdt_vid;
            if(!click_id) {
                return false;
            }

            qq_track({
                actions: [
                    {
                        url: window.location.href,
                        action_time: Math.floor((new Date()).getTime() / 1000),
                        action_type: 'RESERVATION',
                        trace: {
                            click_id: click_id
                        }
                    }
                ]
            }).then(data=>{
            });
        },
        payHandle() {
            //调用加载中
            this.$emit('loadingHandle',true,"支付加载中...");

            if(isWeixin()) {
                wxpay({
                   name:this.name,
                   phone:this.phone,
                   referer:window.location.href,
                   buy_id: this.qrType == 'ff2' ? this.buy_id2 : this.buy_id,
                }).then(data => {
                    let data_ = eval("(" + data.jsApiParameters + ")");
                    let jsApiCall = () => {
                        WeixinJSBridge.invoke("getBrandWCPayRequest", data_, rest => {
                            //关闭加载中
                            this.$emit('loadingHandle',false);
                            WeixinJSBridge.log(rest.err_msg);
                            if (rest.err_msg == "get_brand_wcpay_request:ok") {
                                this.$toast('支付成功');
                                // this.$router.push('/rush_purchase_success');
                                this.showDialog = false;
                            } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
                                alert("支付取消");
                            } else {
                                alert("支付失败");
                            }
                        });
                    };

                    if (typeof WeixinJSBridge == "undefined") {
                    if (document.addEventListener) {
                        document.addEventListener("WeixinJSBridgeReady", jsApiCall, false);
                    } else if (document.attachEvent) {
                        document.attachEvent("WeixinJSBridgeReady", jsApiCall);
                        document.attachEvent("onWeixinJSBridgeReady", jsApiCall);
                    }
                    } else {
                        jsApiCall();
                    }
                });
            } else {
                h5wxpay({
                   name:this.name,
                   phone:this.phone,
                   referer:window.location.href,
                   buy_id: this.qrType == 'ff2' ? this.buy_id2 : this.buy_id,
                }).then(data => {
                    let mweb_url = data.h5Parameters.mweb_url;
                    let trade_no = data.h5Parameters.trade_no;

                    // 缓存trade_no 用于查询订单是否支付成功
                    setStorage(this.$route.path, 'trade_no',trade_no)
                    let seperator = window.location.href.indexOf('?') > 0 ? '&' : '?';
                    let page_url = encodeURIComponent(window.location.href.replace(/[&\?]trade_no=[^&]+/g, '') + seperator + 'trade_no=' + trade_no);
                    window.location.href = `${mweb_url}&redirect_url=${page_url}`;
                });
                
            }
            
        },
        pullData(onNotPaid, onPaid){
            if(isWeixin()) {
                orders({
                    buy_id: this.qrType == 'ff2' ? this.buy_id2 : this.buy_id,
                }).then((data)=>{
                    if (data.code == 10002) {
                        this.$toast(data.data.msg);
                        return false;
                    }
                    this.data = data;

                    if(data.orders.length>0){
                        if(onPaid) {
                            onPaid();
                        }
                        this.isBuy = true;
                        this.qrcodeShow = true;
                        this.bodyShow = true;
                        // this.$router.push('/rush_purchase_success');
                        return
                    } else if (onNotPaid) {
                        if(onNotPaid()){
                            return;
                        }
                    }
                    
                    this.bodyShow = true;
                    
                    let obj = getStorage(this.$route.path, 'userObj');
                    if(obj && String(obj)!='{}'){
                        this.name = obj.name;
                        this.phone = obj.phone;
                        this.checkBool = obj.checkBool;
                    }
                });
            } else {
                //  || 
                let trade_no =queryString(location.href,'trade_no')?queryString(location.href,'trade_no'):getStorage(this.$route.path, 'trade_no');

                checkpay({
                    trade_no: trade_no
                }).then((data=>{
                    if (data.code == 10002) {
                        this.$toast(data.data.msg);
                        return false;
                    }
                    this.data = data;

                    if(data.is_buy){
                        if(onPaid) {
                            onPaid();
                        }

                        this.isBuy = true;
                        this.qrcodeShow = true;
                        this.bodyShow = true;
                        // this.$router.push('/rush_purchase_success');
                        return
                    } else if (onNotPaid) {
                        if(onNotPaid()){
                            return;
                        }
                    }
                    
                    this.bodyShow = true;
                    let obj = getStorage(this.$route.path, 'userObj');
                    if(obj && String(obj)!='{}'){
                        this.name = obj.name;
                        this.phone = obj.phone;
                        this.checkBool = obj.checkBool;
                    }
                }));
            }
            
        },
        addScript: function() {
            let jquery_url = 'https://statics-cdn.xjy.cn/js/jquery-2.1.4.min.js';

            if(!window.jQuery) {
                let script1 = document.createElement('script');
                script1.type = 'text/javascript';
                script1.src = jquery_url;
                document.getElementsByTagName('head')[0].appendChild(script1);
            }


            let mantis_url = ['ff1','ff2'].indexOf(this.$route.query.sou) > - 1 ? 'https://chatn9.bjmantis.net/chat/js/dist/mantis.min.js?6375#5f1666f730b02403751e31fc' : 'https://chatn9.bjmantis.net/chat/js/dist/mantis.min.js?6375#5f16670ba95cf511bc056a34';

            if(!window.mantis) {
                let script2 = document.createElement('script');
                script2.type = 'text/javascript';
                script2.src = mantis_url;
                document.getElementsByTagName('head')[0].appendChild(script2);
            }
        },
    },
    created(){
        document.title = "职业生涯规划师-新精英生涯";
        this.qrType = this.$route.query.sou || '';

        this.addScript();
        let trade_no =queryString(location.href,'trade_no')?queryString(location.href,'trade_no'):getStorage(this.$route.path, 'trade_no');
        if(trade_no === 'true') {
            this.qrcodeShow = true;
            this.bodyShow = true;
        } else if(queryString(location.href,'trade_no')){
            //调用加载中
            this.$emit('loadingHandle',true,"支付结果查询中...");
            let onPaid = () => {
                this.$emit('loadingHandle',false);
            }
            let onNotPaid = () => {
                if(this.retry>0) {
                    this.retry--;
                    setTimeout(()=>{
                        this.pullData(onNotPaid, onPaid);
                    }, 1000);
                    return true;
                } else {
                    this.$emit('loadingHandle',false);
                    return false;
                }
            }
            this.pullData(onNotPaid, onPaid);
        }else{
            this.pullData();
        }
    }
}
</script>

<style lang="scss" scoped>
.media-rush{
    position: fixed;
    width: 750px;
    max-width: 750px;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    z-index: 888;
    .media-rush-img{
        width: 750px;
        height: 120px;
        position: relative;
    }
    .timer-box {
        width: 38px;
        height: 38px;
        line-height: 38px;
        font-family: Arial,sans-serif;
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        color: #fff;
        position: absolute;
        top: 30px;
    }
    .xh {
        left: 285px;
    }
    .xm {
        left: 356px;
    }
    .xs {
        left: 428px;
    }
    
    @keyframes mymove{
        0%{
            transform: scale(1);  /*开始为原始大小*/
        }
        25%{
            transform: scale(.95); /*放大1.1倍*/
        }
        50%{
            transform: scale(1);
        }
        75%{
            transform: scale(.95);
        }

    }

    @-webkit-keyframes mymove 
    {
        0%{
            transform: scale(1);  /*开始为原始大小*/
        }
        25%{
            transform: scale(.95); /*放大1.1倍*/
        }
        50%{
            transform: scale(1);
        }
        75%{
            transform: scale(.95);
        }
    }
    .media-rush-btn{
        position: absolute;
        width: 216px;
        height: 75px;
        top: 24px;
        right: 37px;
        animation:mymove 1s infinite;
        -webkit-animation:mymove 1s infinite; /*Safari and Chrome*/
        animation-direction:alternate;/*轮流反向播放动画。*/
        animation-timing-function: ease-in-out; /*动画的速度曲线*/
        /* Safari 和 Chrome */
        -webkit-animation:mymove 1s infinite;
        -webkit-animation-direction:alternate;/*轮流反向播放动画。*/
        -webkit-animation-timing-function: ease-in-out; /*动画的速度曲线*/
    }
}

.rush-main{
    background-color: #ffffff;
    text-align: center;
    // padding-bottom: 128px;
    img{
        width: 100%;
        max-width: 750px;
    }
    .pb {
        padding-bottom: 120px;
    }
}

.rush-main ::v-deep .van-popup {
    background-color: transparent;
}

.rush-main ::v-deep .van-overlay {
    background-color: rgba(0, 0, 0, 0.8) !important;
}

.rush-confirm {
    img {
        width: 600px;
        border-radius: 10px;
    }
    
    .btn-group {
        padding-top: 50px;
        line-height: 80px;
        font-size: 32px;
        text-align: center;

        .btn-cancel {
            display: inline-block;
            width: 280px;
            height: 80px;
            background-color: #ccc;
            color: #fff;
            border-radius: 10px;
            margin-right: 20px;
        }
        .btn-confirm {
            display: inline-block;
            width: 280px;
            height: 80px;
            background-color: #136ef8;
            color: #fff;
            border-radius: 10px;
            margin-left: 20px;
        }
    }
}

.rush-dialog {
    position: relative;
    width: 648px;
    height: 537px;

    & > img {
        width: 100%;
        height: 100%;
    }

    .phone {
        display: block;
        box-sizing: border-box;
        margin: 0;
        padding: 0 32px;
        border: none;
        background: none;
        position: absolute;
        top: 197px;
        left: 26px;
        width: 596px;
        height: 72px;
        font-size: 32px;
        font-weight: 400;
        color: #333;
        line-height: 72px;
        letter-spacing: 5px;

        &::placeholder {
            color: #333;
        }
    }

    .code {
        display: block;
        box-sizing: border-box;
        margin: 0;
        padding: 0 32px;
        border: none;
        background: none;
        position: absolute;
        top: 309px;
        left: 26px;
        width: 370px;
        height: 72px;
        font-size: 32px;
        font-weight: 400;
        color: #333;
        line-height: 72px;
        letter-spacing: 5px;

        &::placeholder {
            color: #333;
        }
    }

    .valid {
        display: block;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        border: none;
        background: none;
        position: absolute;
        top: 309px;
        left: 408px;
        width: 214px;
        height: 72px;
        border-radius: 36px;
        text-align: center;
        font-size: 29px;
        font-weight: 600;
        color: #fff;
        line-height: 72px;
        letter-spacing: 4px;
    }

    .btn {
        display: block;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        border: none;
        background: none;
        position: absolute;
        top: 421px;
        left: 26px;
        width: 595px;
        height: 86px;
    }

    .time {
        display: block;
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        border: none;
        background: none;
        position: absolute;
        top: 54px;
        right: 106px;
        font-size: 40px;
        font-weight: 600;
        color: #323232;
        line-height: 56px;
    }
}
</style>
